import axiosInstance from './../providers/Axios';

import { regionsMarket } from '../config/paths';

export const callGetRegions = async () => {
  return axiosInstance({
    url: regionsMarket,
    method: 'get',
  });
};
